export default "/fonts/vendor/boxicons/boxicons.woff2?60f603cccbdff82a523c0baa4ec54ef8";